import React, { useState, useEffect } from "react";
import axios from "axios";
import "../App.css";
import Sidebar from "../componenteExtra/SidebarAdmin";
import { Toaster, toast } from "react-hot-toast";
import Modal from "react-modal";
import SessionManager from "../componenteExtra/SessionManager";
import bcrypt from "bcryptjs";

Modal.setAppElement("#root");

const roles = [
  "Solicitante GET",
  "Socio GET",
  "Senior GET",
  "Lider",
  "Subrogante",
  "Staff",
  "Admin",
];

const VerUsuarios = () => {
  const [userList, setUserList] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [editingUserId, setEditingUserId] = useState(null);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [editModalIsOpen, setEditModalIsOpen] = useState(false);
  const [deactivateModalIsOpen, setDeactivateModalIsOpen] = useState(false);
  const [userToDeactivate, setUserToDeactivate] = useState(null);
  const [newUser, setNewUser] = useState({
    id: null,
    numero_grupo: "",
    nombre_get: "",
    rol: "",
    rol2: "",
    correo: "",
    contraseña: "",
    id_jefe_directo: "",
    id_jefe_directo_2: "",
  });

  const token = localStorage.getItem("access_token");

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = () => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/get_all_users`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => setUserList(response.data))
      .catch((error) => {
        console.error("Error al obtener usuarios:", error);
        toast.error("Error al cargar la lista de usuarios.");
      });
  };

  const openModal = () => {
    setIsEditing(false);
    setNewUser({
      id: null,
      numero_grupo: "",
      nombre_get: "",
      rol: "",
      rol2: "",
      correo: "",
      contraseña: "",
      id_jefe_directo: "",
      id_jefe_directo_2: "",
    });
    setModalIsOpen(true);
  };

  const closeModal = () => setModalIsOpen(false);

  const closeEditModal = () => {
    setIsEditing(false);
    setEditingUserId(null);
    setEditModalIsOpen(false);
    setNewUser({
      id: null,
      numero_grupo: "",
      nombre_get: "",
      rol: "",
      rol2: "",
      correo: "",
      contraseña: "",
      id_jefe_directo: "",
      id_jefe_directo_2: "",
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewUser({
      ...newUser,
      [name]:
        value.trim() === ""
          ? ""
          : name === "numero_grupo" || name === "id_jefe_directo" || name === "id_jefe_directo_2"
          ? parseInt(value) || ""
          : value,
    });
  };

  const handleAddUser = async () => {
    // Validar campos obligatorios
    if (!newUser.nombre_get || !newUser.rol || !newUser.correo || (!isEditing && !newUser.contraseña)) {
      toast.error(
        `Por favor, completa los campos obligatorios: Nombre, Rol, Correo${
          isEditing ? ". La contraseña es opcional." : " y Contraseña."
        }`
      );
      return;
    }

    try {
      // Hashear la contraseña si se proporciona
      const hashedPassword = newUser.contraseña
        ? await bcrypt.hash(newUser.contraseña, 10)
        : null;

      // Preparar los datos del usuario para enviar
      const userToSend = {
        nombre_get: newUser.nombre_get,
        rol: newUser.rol,
        correo: newUser.correo,
        contraseña: hashedPassword, // Enviar null si no se proporciona contraseña
        rol2: newUser.rol2 || null,
        numero_grupo: newUser.numero_grupo ? parseInt(newUser.numero_grupo) : null,
        id_jefe_directo: newUser.id_jefe_directo ? parseInt(newUser.id_jefe_directo) : null,
        id_jefe_directo_2: newUser.id_jefe_directo_2 ? parseInt(newUser.id_jefe_directo_2) : null,
      };

      if (isEditing && editingUserId) {
        // Modificar usuario
        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/modify_user/${editingUserId}`,
          userToSend,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        toast.success("Usuario modificado con éxito!");
        fetchUsers();
        closeEditModal(); // Cerrar el modal de edición
      } else {
        // Agregar usuario
        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/add_user`,
          userToSend,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        toast.success("Usuario añadido con éxito!");
        fetchUsers();
        closeModal();
      }
    } catch (error) {
      console.error("Error en la API:", error.response?.data || error);
      toast.error(
        error.response?.data?.detail || `Error al ${isEditing ? "modificar" : "añadir"} usuario.`
      );
    }
  };

  const openEditModal = (user) => {
    setIsEditing(true);
    setEditingUserId(user.id);
    setNewUser({
      id: user.id,
      numero_grupo: user.numero_grupo || "",
      nombre_get: user.nombre_get,
      rol: user.rol,
      rol2: user.rol2 || "",
      correo: user.correo,
      contraseña: "", // No mostrar la contraseña existente
      id_jefe_directo: user.id_jefe_directo || "",
      id_jefe_directo_2: user.id_jefe_directo_2 || "",
    });
    setEditModalIsOpen(true);
  };

  const openDeactivateModal = (userId) => {
    setUserToDeactivate(userId);
    setDeactivateModalIsOpen(true);
  };

  const handleDeactivateUser = () => {
    axios
      .put(
        `${process.env.REACT_APP_BACKEND_URL}/desactivar_usuario/${userToDeactivate}`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(() => {
        toast.success("Usuario desactivado!");
        fetchUsers();
        setDeactivateModalIsOpen(false);
      })
      .catch((error) => {
        console.error("Error al desactivar usuario:", error);
        toast.error("Error al desactivar usuario.");
      });
  };

  return (
    <div className="app">
      <SessionManager />
      <Sidebar />
      <div className="main-content">
        <div className="main-panel">
          <h1>Usuarios GET View</h1>
          <button className="add-user-btn" onClick={openModal}>
            ➕ Agregar Usuario
          </button>
          <table className="users-table">
            <thead>
              <tr>
                <th>ID usuario</th>
                <th>Estado</th>
                <th>Número Grupo</th>
                <th>Nombre</th>
                <th>Rol</th>
                <th>Rol 2</th>
                <th>Correo</th>
                <th>Jefe Directo</th>
                <th>Jefe Directo 2</th>
                <th>Fecha de ingreso</th>
                <th>Fecha de modificación</th>
                <th>Fecha de desactivación</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {userList.map((user) => (
                <tr key={user.id}>
                  <td>{user.id}</td>
                  <td>
                    <span
                      className={user.estado === "activo" ? "estado-activo" : "estado-inactivo"}
                    >
                      {user.estado}
                    </span>
                  </td>
                  <td>{user.numero_grupo}</td>
                  <td>{user.nombre_get}</td>
                  <td>{user.rol}</td>
                  <td>{user.rol2}</td>
                  <td>{user.correo}</td>
                  <td>{user.id_jefe_directo}</td>
                  <td>{user.id_jefe_directo_2}</td>
                  <td>{user.fecha_inscripcion}</td>
                  <td>{user.fecha_modificacion}</td>
                  <td>{user.fecha_desactivacion}</td>
                  <td>
                    <button
                      onClick={() => openEditModal(user)}
                      className="edit-button"
                    >
                      ✏️Modificar
                    </button>
                    <button
                      onClick={() => openDeactivateModal(user.id)}
                      className="delete-button"
                    >
                      🚫Desactivar
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {/* Modal para Agregar Usuario */}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <h2>Añadir Nuevo Usuario</h2>
        <select
          name="numero_grupo"
          onChange={handleInputChange}
          value={newUser.numero_grupo}
        >
          <option value="">Seleccione un grupo</option>
          {[1, 2, 3, 4].map((num) => (
            <option key={num} value={num}>{num}</option>
          ))}
        </select>
        <input
          type="text"
          name="nombre_get"
          placeholder="Nombre"
          value={newUser.nombre_get}
          onChange={handleInputChange}
        />
        <select name="rol" value={newUser.rol} onChange={handleInputChange}>
          <option value="">Seleccione un rol</option>
          {roles.map((role) => (
            <option key={role} value={role}>{role}</option>
          ))}
        </select>
        <select name="rol2" value={newUser.rol2} onChange={handleInputChange}>
          <option value="">Seleccione un rol 2</option>
          {roles.map((role) => (
            <option key={role} value={role}>{role}</option>
          ))}
        </select>
        <input
          type="email"
          name="correo"
          placeholder="Correo"
          value={newUser.correo}
          onChange={handleInputChange}
        />
        <input
          type="password"
          name="contraseña"
          placeholder="Contraseña"
          value={newUser.contraseña}
          onChange={handleInputChange}
        />
        <input
          type="number"
          name="id_jefe_directo"
          placeholder="Ingresa el ID del usuario que es jefe directo de este usuario si es solicitante"
          value={newUser.id_jefe_directo}
          onChange={handleInputChange}
        />
        <input
          type="number"
          name="id_jefe_directo_2 "
          placeholder="Ingresa el 2do ID del usuario que es jefe directo de este usuario si es solicitante"
          value={newUser.id_jefe_directo_2}
          onChange={handleInputChange}
        />
        <button onClick={handleAddUser} className="submit-button">
          Añadir Usuario
        </button>
        <button onClick={closeModal} className="close-button">
          Cerrar
        </button>
      </Modal>

      {/* Modal para Modificar Usuario */}
      <Modal
        isOpen={editModalIsOpen}
        onRequestClose={closeEditModal}
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <h2>Modificar Usuario</h2>
        <select
          name="numero_grupo"
          onChange={handleInputChange}
          value={newUser.numero_grupo}
        >
          <option value="">Seleccione un grupo</option>
          {[1, 2, 3, 4].map((num) => (
            <option key={num} value={num}>{num}</option>
          ))}
        </select>
        <input
          type="text"
          name="nombre_get"
          placeholder="Nombre"
          value={newUser.nombre_get}
          onChange={handleInputChange}
        />
        <select name="rol" value={newUser.rol} onChange={handleInputChange}>
          <option value="">Seleccione un rol</option>
          {roles.map((role) => (
            <option key={role} value={role}>{role}</option>
          ))}
        </select>
        <select name="rol2" value={newUser.rol2} onChange={handleInputChange}>
          <option value="">Seleccione un rol 2</option>
          {roles.map((role) => (
            <option key={role} value={role}>{role}</option>
          ))}
        </select>
        <input
          type="email"
          name="correo"
          placeholder="Correo"
          value={newUser.correo}
          onChange={handleInputChange}
        />
        <input
          type="password"
          name="contraseña"
          placeholder="Nueva Contraseña (opcional)"
          value={newUser.contraseña}
          onChange={handleInputChange}
        />
        <input
          type="number"
          name="id_jefe_directo"
          placeholder="Ingresa el ID del usuario que es jefe directo de este usuario si es solicitante"
          value={newUser.id_jefe_directo}
          onChange={handleInputChange}
        />
          <input
          type="number"
          name="id_jefe_directo_2"
          placeholder="Ingresa el 2do ID del usuario que es jefe directo de este usuario si solicitante"
          value={newUser.id_jefe_directo_2}
          onChange={handleInputChange}
        />
        <button onClick={handleAddUser} className="submit-button">
          Guardar Cambios
        </button>
        <button onClick={closeEditModal} className="close-button">
          Cerrar
        </button>
      </Modal>
      <Modal
        isOpen={deactivateModalIsOpen}
        onRequestClose={() => setDeactivateModalIsOpen(false)}
        className="custom-modal"
      >
        <h2>¿Deseas desactivar este usuario?</h2>
        <div className="modal-buttons">
          <button
            onClick={handleDeactivateUser}
            className="deactivate-button"
          >
            Sí, desactivar
          </button>
          <button
            onClick={() => setDeactivateModalIsOpen(false)}
            className="back-button"
          >
            Atrás
          </button>
        </div>
      </Modal>
      <Toaster />
    </div>
  );
};

export default VerUsuarios;